import { AxiosError } from '@helpers/httpClient'
import { createSlice } from '@reduxjs/toolkit'

import {
  GENERATE_PROOF_OF_STUDY,
  GLOBAL_STATE,
  STUDENT,
  STUDENT_ACHIEVEMENT_RECORDS,
  STUDENT_ALL,
  STUDENT_CONTACT_INFO,
  STUDENT_DELETE,
  STUDENT_FULL_INFO,
  STUDENT_GUARD_CREATE,
  STUDENT_GUARD_LIST,
  STUDENT_LIST,
  STUDENT_PERSONAL_INFO,
  STUDENT_PUBLIC_STUDY_PROOF,
  STUDENT_PUBLIC_TRANSCRIPT,
  STUDENT_STATUS_UPDATE,
  STUDENT_USERNAME,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const STUDENTS = GLOBAL_STATE

const studentSlice = createSlice({
  name: STUDENTS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.student.pending, state => {
        state[STUDENT].loading = true
      })
      .addCase(actionCreators.student.rejected, (state, action) => {
        state[STUDENT].loading = false
        state[STUDENT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.student.fulfilled, (state, action) => {
        state[STUDENT].loading = false
        state[STUDENT].error = null
        state[STUDENT].data = action.payload
      })

    builder
      .addCase(actionCreators.studentAchievementRecords.pending, state => {
        state[STUDENT_ACHIEVEMENT_RECORDS].loading = true
      })
      .addCase(actionCreators.studentAchievementRecords.rejected, (state, action) => {
        state[STUDENT_ACHIEVEMENT_RECORDS].loading = false
        state[STUDENT_ACHIEVEMENT_RECORDS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentAchievementRecords.fulfilled, (state, action) => {
        state[STUDENT_ACHIEVEMENT_RECORDS].loading = false
        state[STUDENT_ACHIEVEMENT_RECORDS].error = null
        state[STUDENT_ACHIEVEMENT_RECORDS].data = action.payload
      })

    builder
      .addCase(actionCreators.studentAll.pending, state => {
        state[STUDENT_ALL].loading = true
      })
      .addCase(actionCreators.studentAll.rejected, (state, action) => {
        state[STUDENT_ALL].loading = false
        state[STUDENT_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentAll.fulfilled, (state, action) => {
        state[STUDENT_ALL].loading = false
        state[STUDENT_ALL].error = null
        state[STUDENT_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.studentContactInfo.pending, state => {
        state[STUDENT_CONTACT_INFO].loading = true
      })
      .addCase(actionCreators.studentContactInfo.rejected, (state, action) => {
        state[STUDENT_CONTACT_INFO].loading = false
        state[STUDENT_CONTACT_INFO].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentContactInfo.fulfilled, (state, action) => {
        state[STUDENT_CONTACT_INFO].loading = false
        state[STUDENT_CONTACT_INFO].error = null
        state[STUDENT_CONTACT_INFO].data = action.payload
      })

    builder
      .addCase(actionCreators.studentDelete.pending, state => {
        state[STUDENT_DELETE].loading = true
      })
      .addCase(actionCreators.studentDelete.rejected, (state, action) => {
        state[STUDENT_DELETE].loading = false
        state[STUDENT_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentDelete.fulfilled, (state, action) => {
        state[STUDENT_DELETE].loading = false
        state[STUDENT_DELETE].error = null
        state[STUDENT_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.studentGuardCreate.pending, state => {
        state[STUDENT_GUARD_CREATE].loading = true
      })
      .addCase(actionCreators.studentGuardCreate.rejected, (state, action) => {
        state[STUDENT_GUARD_CREATE].loading = false
        state[STUDENT_GUARD_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentGuardCreate.fulfilled, (state, action) => {
        state[STUDENT_GUARD_CREATE].loading = false
        state[STUDENT_GUARD_CREATE].error = null
        state[STUDENT_GUARD_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.studentGuardList.pending, state => {
        state[STUDENT_GUARD_LIST].loading = true
      })
      .addCase(actionCreators.studentGuardList.rejected, (state, action) => {
        state[STUDENT_GUARD_LIST].loading = false
        state[STUDENT_GUARD_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentGuardList.fulfilled, (state, action) => {
        state[STUDENT_GUARD_LIST].loading = false
        state[STUDENT_GUARD_LIST].error = null
        state[STUDENT_GUARD_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.studentList.pending, state => {
        state[STUDENT_LIST].loading = true
      })
      .addCase(actionCreators.studentList.rejected, (state, action) => {
        state[STUDENT_LIST].loading = false
        state[STUDENT_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentList.fulfilled, (state, action) => {
        state[STUDENT_LIST].loading = false
        state[STUDENT_LIST].error = null
        state[STUDENT_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.studentPersonalInfo.pending, state => {
        state[STUDENT_PERSONAL_INFO].loading = true
      })
      .addCase(actionCreators.studentPersonalInfo.rejected, (state, action) => {
        state[STUDENT_PERSONAL_INFO].loading = false
        state[STUDENT_PERSONAL_INFO].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentPersonalInfo.fulfilled, (state, action) => {
        state[STUDENT_PERSONAL_INFO].loading = false
        state[STUDENT_PERSONAL_INFO].error = null
        state[STUDENT_PERSONAL_INFO].data = action.payload
      })

    builder
      .addCase(actionCreators.studentFullInfo.pending, state => {
        state[STUDENT_FULL_INFO].loading = true
      })
      .addCase(actionCreators.studentFullInfo.rejected, (state, action) => {
        state[STUDENT_FULL_INFO].loading = false
        state[STUDENT_FULL_INFO].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentFullInfo.fulfilled, (state, action) => {
        state[STUDENT_FULL_INFO].loading = false
        state[STUDENT_FULL_INFO].error = null
        state[STUDENT_FULL_INFO].data = action.payload
      })

    builder
      .addCase(actionCreators.studentStatusUpdate.pending, state => {
        state[STUDENT_STATUS_UPDATE].loading = true
      })
      .addCase(actionCreators.studentStatusUpdate.rejected, (state, action) => {
        state[STUDENT_STATUS_UPDATE].loading = false
        state[STUDENT_STATUS_UPDATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentStatusUpdate.fulfilled, (state, action) => {
        state[STUDENT_STATUS_UPDATE].loading = false
        state[STUDENT_STATUS_UPDATE].error = null
        state[STUDENT_STATUS_UPDATE].data = action.payload
      })

    builder
      .addCase(actionCreators.studentUsername.pending, state => {
        state[STUDENT_USERNAME].loading = true
      })
      .addCase(actionCreators.studentUsername.rejected, (state, action) => {
        state[STUDENT_USERNAME].loading = false
        state[STUDENT_USERNAME].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentUsername.fulfilled, (state, action) => {
        state[STUDENT_USERNAME].loading = false
        state[STUDENT_USERNAME].error = null
        state[STUDENT_USERNAME].data = action.payload
      })

    builder
      .addCase(actionCreators.studentPublicTranscript.pending, state => {
        state[STUDENT_PUBLIC_TRANSCRIPT].loading = true
      })
      .addCase(actionCreators.studentPublicTranscript.rejected, (state, action) => {
        state[STUDENT_PUBLIC_TRANSCRIPT].loading = false
        state[STUDENT_PUBLIC_TRANSCRIPT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentPublicTranscript.fulfilled, (state, action) => {
        state[STUDENT_PUBLIC_TRANSCRIPT].loading = false
        state[STUDENT_PUBLIC_TRANSCRIPT].error = null
        state[STUDENT_PUBLIC_TRANSCRIPT].data = action.payload
      })

    builder
      .addCase(actionCreators.studentPublicStudyProof.pending, state => {
        state[STUDENT_PUBLIC_STUDY_PROOF].loading = true
      })
      .addCase(actionCreators.studentPublicStudyProof.rejected, (state, action) => {
        state[STUDENT_PUBLIC_STUDY_PROOF].loading = false
        state[STUDENT_PUBLIC_STUDY_PROOF].error = action.payload as AxiosError
      })
      .addCase(actionCreators.studentPublicStudyProof.fulfilled, (state, action) => {
        state[STUDENT_PUBLIC_STUDY_PROOF].loading = false
        state[STUDENT_PUBLIC_STUDY_PROOF].error = null
        state[STUDENT_PUBLIC_STUDY_PROOF].data = action.payload
      })

    builder
      .addCase(actionCreators.generateProofOfStudy.pending, state => {
        state[GENERATE_PROOF_OF_STUDY].loading = true
      })
      .addCase(actionCreators.generateProofOfStudy.rejected, (state, action) => {
        state[GENERATE_PROOF_OF_STUDY].loading = false
        state[GENERATE_PROOF_OF_STUDY].error = action.payload as AxiosError
      })
      .addCase(actionCreators.generateProofOfStudy.fulfilled, (state, action) => {
        state[GENERATE_PROOF_OF_STUDY].loading = false
        state[GENERATE_PROOF_OF_STUDY].error = null
        state[GENERATE_PROOF_OF_STUDY].data = action.payload
      })

    builder.addCase(actionCreators.studentPublicStudyProofClear, state => {
      state[STUDENT_PUBLIC_STUDY_PROOF] = defaultState()
    })

    builder.addCase(actionCreators.studentClear, state => {
      state[STUDENT] = defaultState()
    })

    builder.addCase(actionCreators.studentAchievementRecordsClear, state => {
      state[STUDENT_ACHIEVEMENT_RECORDS] = defaultState()
    })

    builder.addCase(actionCreators.studentAllClear, state => {
      state[STUDENT_ALL] = defaultState()
    })

    builder.addCase(actionCreators.studentGuardListClear, state => {
      state[STUDENT_GUARD_LIST] = defaultState()
    })

    builder.addCase(actionCreators.studentListClear, state => {
      state[STUDENT_LIST] = defaultState()
    })

    builder.addCase(actionCreators.studentUsernameClear, state => {
      state[STUDENT_USERNAME] = defaultState()
    })

    builder.addCase(actionCreators.studentPublicTranscriptClear, state => {
      state[STUDENT_PUBLIC_TRANSCRIPT] = defaultState()
    })
  },
})

export const { reducer: studentReducer } = studentSlice
